/**
 * Connectivity signal for the offline/pending-sync UI spec §5 and §13
 * require ("show online/offline + pending-sync status"). navigator.onLine
 * is a coarse, browser-reported signal (it can say "online" while the
 * Wi-Fi is actually too weak to reach the Worker) — it's used here only
 * to decide when to *attempt* a flush of the offline queue, never to
 * skip the try/catch around the actual request. A request that fails
 * despite navigator.onLine saying true still falls back to the offline
 * queue (see offlineQueue.ts / screens/scan.ts) — this is a hint, not a
 * guarantee.
 */
export function isOnline(): boolean {
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}

export function onConnectivityChange(handler: (online: boolean) => void): () => void {
  const goOnline = () => handler(true);
  const goOffline = () => handler(false);
  window.addEventListener('online', goOnline);
  window.addEventListener('offline', goOffline);
  return () => {
    window.removeEventListener('online', goOnline);
    window.removeEventListener('offline', goOffline);
  };
}
